import { axiosClient } from '@nx-frontend/shared/api';
import { OrgServiceOrgDto } from '@nx-frontend/shared/types';

interface SetOrgPayload {
  userId: number;
  orgId: string;
  payload: {
    isShareAdEnabled?: boolean;
  };
}

export async function updateOrg({ userId, orgId, payload }: SetOrgPayload): Promise<OrgServiceOrgDto> {
  const response = await axiosClient.post<OrgServiceOrgDto>(`/v2/api/orgs/${orgId}`, payload, { userId });

  return response.data;
}
